// extracted by mini-css-extract-plugin
export default {"navigate":"Navigate_navigate__wZZrq","active":"Navigate_active__Ntw3r"};